<template>
    <div>
        <slideModal v-model="showDialog" width="1080px">
            <template slot="title">
                字段映射
            </template>
            <div class="content">
                <hc-form ref="tableForm" label-position="left" label-width="0px" :rules="rules" :model="tableFormObj" :inline-message="true" @validate="onTableFormObjValidateFunc">
                    <hc-table
                        :data="tableFormObj.tableDataArr"
                        row-key="id"
                        default-expand-all
                        height="100%"
                        :indent="8"
                        :row-class-name="rowClassName"
                        :tree-props="{ children: 'fields' }"
                        @row-click="tableRowClick"
                    >
                        <hc-table-column label="名称" prop="nodeName" show-overflow-tooltip>
                            <template slot-scope="{ row }">
                                <span>{{ row.nodeName }}</span>
                                <span class="table-object-type">{{ row.type }}</span>
                            </template>
                        </hc-table-column>

                        <hc-table-column v-if="showRequired" label="必填" width="64px">
                            <template slot-scope="{ row }">
                                <span class="table-object-required">{{ row.required ? '是' : '否' }}</span>
                            </template>
                        </hc-table-column>

                        <hc-table-column label="处理" width="320px">
                            <template slot-scope="{ $index, row }">
                                <div class="table-object-handle">
                                    <div class="table-object-handle--item" style="flex: initial;width: 104px">
                                        <hc-form-item v-if="!row.disable && (row.type === 'object' || row.type === 'objectArray') && row.handle !== 'matching'" :prop="getFormItemProp(row, 'handle')">
                                            <hc-select
                                                v-model="row.handle"
                                                style="width: 104px"
                                                placeholder="请选择处理方式"
                                                @change="tableColumnSelectChange(row, true)"
                                            >
                                                <hc-option key="generate" label="创建对象" value="generate" />
                                                <hc-option v-if="$index !== 0 && !row.noRelevance" key="relevance" label="关联对象" value="relevance" />
                                                <hc-option v-if="$index === 0 ? rootHasObj: row.notProcess" key="notProcess" label="不处理" value="notProcess" />
                                            </hc-select>
                                        </hc-form-item>
                                        <template v-else>
                                            {{ '--' }}
                                        </template>
                                    </div>
                                    <div class="table-object-handle--item">
                                        <!-- 父级节点为关联对象 项包含英文名是节点名称的业务对象-->
                                        <hc-form-item v-if="!row.disable && (row.type === 'object' || row.type === 'objectArray') && row.handle === 'relevance'" key="objectId" :prop="getFormItemProp(row, 'objectId')" :rules="rules.object">
                                            <hc-object-selector v-model="row.objectId" @change="objectChange(row)" />
                                        </hc-form-item>
                                    </div>
                                </div>
                            </template>
                        </hc-table-column>

                        <hc-table-column label="显示名称&英文名称" width="330px">
                            <template slot-scope="{row}">
                                <div class="table-object-display-name">
                                    <div class="table-object-display-name--item">
                                        <hc-form-item v-if="showDisplayName(row)" key="title" :prop="getFormItemProp(row, 'title')" :rules="rules.title">
                                            <hc-input v-model.trim="row.title" placeholder="请输入" />
                                        </hc-form-item>
                                        <template v-else>
                                            <text-over-tooltip ref-name="tableObjectTitle"
                                                :content="showText('title', row)"
                                            />
                                        </template>
                                    </div>
                                    <div class="table-object-display-name--item">
                                        <hc-form-item v-if="showDisplayName(row)" key="name" :prop="getFormItemProp(row, 'name')" :rules="rules.name">
                                            <hc-input v-model.trim="row.name" placeholder="请输入" />
                                        </hc-form-item>
                                        <template v-else>
                                            <text-over-tooltip ref-name="tableObjectName"
                                                :content="showText('name', row)"
                                            />
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </hc-table-column>

                        <hc-table-column label=" " width="36">
                            <template slot-scope="{ $index, row }">
                                <img
                                    v-if="showDisplayName(row) && row.type !== 'object' && row.type !== 'objectArray' && row.type !== 'booleanArray'"
                                    :class="['table-field-icon', $index === showFieldConfigIndex ? 'table-field-icon--active' : '']"
                                    :src="editFieldIcon"
                                    @click="editCurrentRowField(row, $index)"
                                >
                            </template>
                        </hc-table-column>
                    </hc-table>
                </hc-form>
            </div>
            <div slot="footer">
                <div class="footer">
                    <hc-button type="plain" @click="showDialog = false">
                        取消
                    </hc-button>
                    <hc-button type="primary" :loading="saveLoading" @click="save">
                        保存
                    </hc-button>
                </div>
            </div>
        </slideModal>
        <AddFieldModal
            v-if="showFieldConfig"
            width="480px"
            :visible="showFieldConfig"
            :current-obj="editingRow"
            @confirm="confirmConfig"
            @cancel="cancelConfig"
        />
    </div>
</template>

<script>
import _ from 'lodash'

import { mapActions } from 'vuex'
import { logger } from '@mypaas/app-render-engine/core/sdk'
import * as T from '@common/store/app-resource/types'
import { APP_RESOURCE } from '@common/store/module-types'
import { FIELD_REGEXP } from '@common/utils/regExp'
import characterLength from '@common/utils/character-length'
import slideModal from '@common/components/common/slide-modal'
import textOverTooltip from '@common/components/common/text-over-tooltip'
import editFieldIcon from '@common/assets/img/edit-field.svg'
import { getObjectField } from '@common/api/app-resource'
import dialogMixin from '../dialog-mixin'
import AddFieldModal from './add-field-modal'
import { ApiTypeFilterRules } from './const'
import HcObjectSelector from './object-selector'

const validateRepeat = (rule, value, data, keyword) => {
    const itemPath = rule.field.split('.')
    const parentPath = itemPath.filter((f, index) => index !== itemPath.length - 1 && index !== itemPath.length - 2).join('.')

    if (parentPath) {
        const parent = _.get(data, parentPath)
        if (parent && parent.fields) {
            const exit = parent.fields.filter(i => i[keyword] === value)
            return exit.length > 1
        }
    }
    return false
}

const validateCnName = (rule, value, callback, data) => {
    if (characterLength(value) > 50) {
        callback(
            new Error('最大长度不能超过50个字符，一个中文两个字符')
        )
        return
    }
    const repeat = validateRepeat(rule, value, data, 'title')
    if (repeat) {
        callback(
            new Error('字段显示名不能重复')
        )
        return
    }
    callback()
}
const validateField = (rule, value, callback, data) => {
    if (value.length > 30) {
        callback(
            new Error('输入的字段不能超过30个字')
        )
        return
    }
    if (!FIELD_REGEXP.test(value)) {
        callback(new Error('请输入英文、数字、下划线，英文字母开头，不以下划线结尾，且不包含2个连续下划线'))
        return
    }

    const repeat = validateRepeat(rule, value, data, 'name')
    if (repeat) {
        callback(
            new Error('字段英文名称不能重复')
        )
        return
    }
    callback()
}

export default {
    name: 'AddObject',
    components: {
        slideModal,
        AddFieldModal,
        textOverTooltip,
        HcObjectSelector,
    },
    mixins: [dialogMixin],
    props: {
        schema: {
            type: Object,
            default() {
                return {}
            },
        },
        businessEnvId: {
            type: String,
        },
        // objectArr: {
        //     type: Array,
        //     default() {
        //         return []
        //     },
        // },
        apiParamObj: {
            type: Object,
        },
        showRequired: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            createObjectsList: [],
            editFieldIcon,
            ApiTypeFilterRules,
            tableFormObj: {
                tableDataArr: [],
            },
            handleMap: {
                relevance: '关联对象',
                generate: '创建对象',
                notProcess: '不处理',
            },
            rules: {
                object: [
                    {
                        required: true,
                        message: '请选择对象',
                        trigger: 'blur',
                    },
                ],
                name: [
                    {
                        required: true,
                        message: '英文名称不能为空',
                    },
                    { validator: (rule, value, callback) => validateField(rule, value, callback, this.tableFormObj), trigger: 'change' },
                ],
                title: [
                    {
                        required: true,
                        message: '显示名称不能为空',
                    },
                    { validator: (rule, value, callback) => validateCnName(rule, value, callback, this.tableFormObj), trigger: 'change' },
                ],
            },
            saveLoading: false,
            activeIndex: -1,
            rootHasObj: true,
            errorRowIndex: [],
            showFieldConfig: false,
            showFieldConfigIndex: null,
            editingRow: null,
        }
    },
    watch: {
        showDialog(val) {
            if (val) {
                this.schema.isRoot = true
                this.tableFormObj.tableDataArr = this.formatSchema([this.schema])
                const root = this.tableFormObj.tableDataArr[0]
                this.rootHasObj = (root.fields || []).some(item => ['object', 'objectArray'].includes(item.type))
                root.handle = this.rootHasObj ? 'notProcess' : 'generate'
                this.tableColumnSelectChange(root, false, this.apiParamObj.response.dataName)
            } else {
                this.activeIndex = -1
            }
        },
    },
    mounted() {
        this.appId = this.$route.params.appId
    },
    methods: {
        ...mapActions(APP_RESOURCE, {
            getObject: T.GET_NEW_OBJECT,
            getObjectDtl: T.GET_NEW_OBJECT_DTL,
            createObject: T.BATCH_CREATE_OBJECT,
        }),
        showDisplayName(row) {
            if (!row.editable || row.disable || row.handle === 'notProcess') {
                return false
            }
            if (row.handle === 'matching' && !row.relevanceMsg.isMatching) {
                return false
            }
            return true
        },
        confirmConfig(row) {
            this.setFieldByPath(row)
            this.cancelConfig()
        },
        cancelConfig() {
            // this.editingRow = {}
            this.showFieldConfig = false
        },
        editCurrentRowField(row, index) {
            this.showFieldConfigIndex = index
            const defaultConfig = this.ApiTypeFilterRules[row.type]?.defaultConfig
            let config = row.config || defaultConfig
            if (this.showRequired) {
                config = {
                    ...config,
                    required: row.required,
                }
            }
            const matchType = row.matchType || config.type || row.type
            this.editingRow = { ...row, config, matchType }
            this.showFieldConfig = true
        },
        getDisableEnName(row) {
            return !['object', 'objectArray'].includes(row.type)
        },
        objectClick() {
            this.$refs.tableForm && this.$refs.tableForm.clearValidate()
        },
        objectChange(row) {
            if (row.objectId) {
                this.getObjectField(row)
            }
        },
        showText(str, row) {
            if (row.display === 'none') return '--'
            if (row.handle === 'matching' && !row.relevanceMsg.isMatching) return '无匹配项'
            return row[str]
        },

        getObjectField(row) {
            getObjectField({
                objectId: row.objectId,
            }).then(data => {
                const fields = row.fields || []
                const sourcFields = data.items || []
                const { isSystem } = data
                fields.forEach(item => {
                    item.handle = 'matching'
                    // 系统对象不允许被编辑
                    item.editable = !isSystem
                    const index = sourcFields.findIndex(i => i.integrationPlatformName === item.name)
                    if (index === -1) {
                        item.relevanceMsg = {
                            isMatching: false,
                            name: '',
                            title: '',
                        }
                        this.changeFieldsHandle(item, 'matching')
                        return
                    }
                    // 如果是对象的话 继续匹配接下来的字段
                    if (item.type === 'objectArray' || item.type === 'object') {
                        item.objectId = sourcFields[index].typeObjectId
                        this.getObjectField(item)
                    }
                    item.name = sourcFields[index].name
                    item.title = sourcFields[index].title
                    item.matchType = sourcFields[index].type
                    item.config = sourcFields[index].config
                    item.relevanceMsg = {
                        isMatching: true,
                        name: sourcFields[index].name,
                        title: sourcFields[index].title,
                        fieldId: sourcFields[index].id,
                        type: sourcFields[index].type,
                        typeObjectId: sourcFields[index].typeObjectId,
                    }
                })
            })
        },
        changeFieldsHandle(row, value) {
            const fields = row.fields || []
            fields.forEach(item => {
                item.handle = value
                if (value === 'matching' && (!row.relevanceMsg || !row.relevanceMsg.isMatching)) {
                    item.relevanceMsg = {
                        isMatching: false,
                        name: '',
                        title: '',
                    }
                }
                this.changeFieldsHandle(item, value)
            })
        },
        getRelevanceMsg(row) {
            if (row.handle === 'relevance') {
                return row._title || '--'
            }
            if (row.handle === 'matching') {
                if (!row.relevanceMsg.isMatching) return '无匹配项'
                return (row.type === 'object' || row.type === 'objectArray') ? '对象' : '字段'
            }
            return '--'
        },
        formatSchema(schema, parentIsRoot) {
            return schema.map(item => {
                const result = {
                    id: item.id,
                    nodeName: item.name,
                    name: item.name,
                    type: item.type,
                    title: item.title,
                    remark: item.remark,
                    required: item.required,
                    parentIsRoot: !!parentIsRoot,
                    handle: '',
                    editable: true,
                    relevanceMsg: {
                        isMatching: false,
                        name: '',
                        title: '',
                    },
                }
                if (Array.isArray(item.fields) && item.fields.length) {
                    result.fields = this.formatSchema(item.fields, item.isRoot)
                }
                return result
            })
        },
        rowClassName({ row, rowIndex }) {
            row.index = rowIndex
            this.setChildPath(row, rowIndex)
            const hasMatch = this.errorRowIndex.some(item => item.toString() === row.path.toString())
            const errorclass = hasMatch ? 'has_error' : ''
            return `${row.disable ? 'row-disable' : ''} ${errorclass}`
        },
        getFormItemProp(row, field) {
            const { path = [] } = row
            let result = 'tableDataArr[0]'
            path.forEach((item, index) => {
                if (index === 0) return
                result += `.fields[${item}]`
            })
            return `${result}.${field}`
        },
        getTargetField(row, target, pathPerfix = 'tableDataArr[0]', passLast = true) {
            const { path = [] } = row
            let setPath = pathPerfix
            path.forEach((item, index) => {
                if (index === 0) return
                if (index === path.length - 1 && passLast) {
                    setPath += '.fields'
                } else {
                    setPath += `.fields[${item}]`
                }
            })
            return _.get(target, setPath)
        },
        setFieldByPath(row) {
            const { path = [] } = row
            const lastPathIndex = path[path.length - 1]

            const currents = this.getTargetField(row, this.tableFormObj)

            const data = {
                ...row,
                required: _.isBoolean(row.config?.required) ? row.config?.required : row.required,
            }
            console.log('====data', data)
            this.$set(currents, lastPathIndex, data)
        },
        setChildPath(row, rowIndex) {
            if (rowIndex === 0) {
                row.path = [0]
            }
            const child = row.fields
            Array.isArray(child) && child.forEach((item, index) => {
                item.path = [...row.path, index]
            })
        },
        save() {
            this.createObjectsList = []
            this.$refs.tableForm.validate(valid => {
                if (!valid) return
                const tableObj =  this.tableFormObj.tableDataArr[0]
                let updateObjects = []
                updateObjects = this.formatRelevanceData(tableObj)
                this.saveLoading = true
                this.formate(tableObj)
                this.createObject({
                    objects: this.createObjectsList,
                    updateObjects,
                }).then(() => {
                    this.saveLoading = false
                    this.showDialog = false
                    this.$emit('addObjectSuccess')
                }).catch(() => {
                    this.saveLoading = false
                })
            })
        },

        formate(item) {
            if (item.handle === 'generate') {
                this.createObjectsList.push(this.formatSubmitData(item))
            } else if (item.handle === 'relevance') {
                item.fields.forEach(sItem => {
                    if (sItem.type === 'object' || sItem.type === 'objectArray') {
                        this.createObjectsList.push(this.formatSubmitData(sItem))
                    }
                })
            } else {
                item && item.fields && item.fields.forEach(sItem => {
                    this.formate(sItem)
                })
            }
        },
        formatSubmitData(data) {
            let type = data.matchType || data.type
            if (type === 'booleanArray') {
                type = 'stringArray'
            }
            const result = {
                name: data.name,
                type,
                title: data.title,
                integrationPlatformName: data.nodeName,
                required: data.required,
            }
            if (data.config) {
                result.config = data.config
                result.required = data.config.required || result.required
            }
            if (data.handle === 'relevance') {
                result.objectId = data.objectId
                return result
            }
            if (Array.isArray(data.fields) && data.fields.length) {
                result.fields = data.fields.map(i => this.formatSubmitData(i))
            }
            return result
        },

        formatRelevanceData(obj) {
            const updateFields = []

            const genField = (id, data) => {
                const fs = []
                if (!data || data.length < 1) return
                data.forEach(f => {
                    if (f.handle === 'matching' && f.relevanceMsg && f.relevanceMsg.isMatching) {
                        fs.push(f)

                        if ((f.type === 'object' || f.type === 'objectArray') && f.objectId) {
                            genField(f.objectId, f.fields)
                        }
                    }
                })

                if (fs.length > 0) {
                    const res = {
                        businessObjectId: id,
                        fields: fs.map(m => {
                            let type = m.matchType || m.type
                            if (type === 'booleanArray') {
                                type = 'stringArray'
                            }
                            return {
                                fieldId: m.relevanceMsg.fieldId,
                                typeObjectId: m.relevanceMsg.typeObjectId,
                                type,
                                name: m.name,
                                title: m.title,
                                integrationPlatformName: m.nodeName,
                                required: m.config?.required || m.required,
                                config: m.config ? m.config : {},
                            }
                        }),
                    }
                    updateFields.push(res)
                }
            }

            const genData = node => {
                if (node.handle === 'relevance') {
                    genField(node.objectId, node.fields)
                } else if (Array.isArray(node.fields) && node.fields.length) {
                    node.fields.forEach(f => {
                        genData(f)
                    })
                }
            }

            genData(obj)

            return updateFields
        },

        tableRowClick(row) {
            if (row.disable) return
            if (row.index !== this.activeIndex) {
                this.$refs.tableForm.validate(valid => {
                    if (valid) {
                        this.activeIndex = row.index
                    }
                })
            }
            if (this.activeIndex === -1) this.activeIndex = row.index
        },
        async getObjectDtlFn(obj, id) {
            if (!id) {
                return
            }
            try {
                const resData = await this.getObjectDtl({
                    objectId: id,
                })
                this.$set(obj, 'objectName', resData.title)
            } catch (error) {
                logger.log(error)
            }
        },
        tableColumnSelectChange(row, reset = false, dataName = '') {
            reset && this.resetField(row)
            // 此函数是递归的，此处逻辑是处理只将数据内容字段的部分创建对象，其余都为不处理，所以将dataName进行分割识别到最后一级，将handle设为notProcess
            const nameArr = dataName.split('.')
            const currentKey = nameArr.shift()
            const otherKey = nameArr.length ? nameArr.join('.') : ''
            // 如果切换处理方式的话需要重置参数
            if (row.handle === 'notProcess') {
                // 不处理
                const fields = row.fields || []
                for (let i = 0; i < fields.length; i++) {
                    const item = fields[i]
                    reset && this.resetField(item)
                    // 新增规则: 父节点为notProcess，子节点也可以选择 notProcess
                    this.$set(item, 'notProcess', true)
                    this.$set(item, 'editable', true)
                    if (['object', 'objectArray'].includes(item.type)) {
                        this.$set(item, 'disable', false)
                        this.$set(item, 'noRelevance', true)
                        if (item.objectId) {
                            this.$set(item, 'objectId', '')
                        }
                        
                        if (currentKey !== item.name || nameArr.length > 0) {
                            this.$set(item, 'handle', 'notProcess')
                        } else {
                            this.$set(item, 'handle', item.handle && item.handle !== 'relevance' ? item.handle : 'generate')
                        }
                        this.tableColumnSelectChange(item, reset, otherKey)
                    } else {
                        this.$set(item, 'handle', 'notProcess')
                        this.$set(item, 'disable', true)
                    }
                }
            } else if (row.handle === 'generate') {
                // 创建
                const fields = row.fields || []
                if (row.objectId) {
                    this.$set(row, 'objectId', '')
                }
                for (let i = 0; i < fields.length; i++) {
                    const item = fields[i]
                    reset && this.resetField(item)
                    this.$set(item, 'notProcess', false)
                    this.$set(item, 'editable', true)
                    if (['object', 'objectArray'].includes(item.type)) {
                        if (currentKey !== item.name || nameArr.length > 0) {
                            this.$set(item, 'handle', 'notProcess')
                        }
                        this.$set(item, 'handle', 'generate')
                        this.$set(item, 'noRelevance', false)
                        if (item.objectId) {
                            this.$set(item, 'objectId', '')
                        }
                        this.tableColumnSelectChange(item, reset, otherKey)
                    } else {
                        this.$set(item, 'handle', 'generate')
                        this.$set(item, 'disable', false)
                    }
                }
            } else {
                // 关联
                if (row.objectId) {
                    this.objectChange(row)
                } else {
                    const fields = row.fields || []
                    for (let i = 0; i < fields.length; i++) {
                        const item = fields[i]
                        reset && this.resetField(item)
                        this.$set(item, 'notProcess', false)
                        this.$set(item, 'editable', true)
                        if (['object', 'objectArray'].includes(item.type)) {
                            this.tableColumnSelectChange(item, reset, otherKey)
                        } else {
                            this.$set(item, 'handle', 'relevance')
                            this.$set(item, 'disable', false)
                            this.$set(item, 'relevancePath', item.relevancePath ? item.relevancePath : [])
                        }
                    }
                }
            }
        },
        resetField(row) {
            const sourceField = this.getTargetField(row, [this.schema], '[0]', false)
            this.$set(row, 'title', sourceField.title)
            this.$set(row, 'name', sourceField.name)
        },
        disableChild(obj, childName, disable) {
            const child = obj[childName]
            Array.isArray(child) && child.forEach(item => {
                item.disable = disable
                this.$set(item, 'disable', disable)
                this.disableChild(item, childName, disable)
            })
        },

        onTableFormObjValidateFunc(option, status) {
            const errorPath = option.match(/\d+/g)
            const errorRowIndex = [...this.errorRowIndex]
            if (!status) {
                errorRowIndex.push(errorPath)
            } else {
                _.remove(errorRowIndex, item => item.toString() === errorPath.toString())
            }
            this.errorRowIndex = [...errorRowIndex]
        },
    },
}
</script>

<style lang="less">
.hc-select-dropdown.add-object-content__select{
    &__wrap {
        max-height: 337px;
    }
    &__item {
        height: 34px;
        line-height: 34px;
    }
}
</style>
<style lang="less" scoped>
@deep: ~'>>>';
.content {
    padding: 0 20px;
    height: 100%;

    @{deep} {
        .table-field-icon{
            cursor: pointer;
            border-radius: 3px;
            &--active{

            }
        }

        .table-object-handle,
        .table-object-display-name{
            display: flex;
            &--item{
                flex: 1;
                line-height: 32px;
                overflow: hidden;
                .hc-form-item{
                    width: 100%;
                }
                &:first-child{
                    margin-right: 8px !important;
                }
            }
        }
        .table-object-required{
            display: inline-block;
        }
        .table-object-type{
            margin-left: 8px;
            font-size: 13px;
            color: #999999;
            line-height: 22px;
        }
        .object-picker__body {
            width: 130px;
        }
        .row-disable {
            cursor: not-allowed;
            opacity: 0.6;
        }
    }

    @{deep} {
        .hc-form{
            height: 100%;
        }
        .hc-form-item {
            margin: 0 !important;
        }
        .hc-form-item__content{
            line-height: normal;
        }
        .hc-table__header-wrapper .hc-table__cell{
            background: #FBFBFB;
            .cell{
                font-size: 13px;
                font-weight: 400;
                line-height: 22px;
                color: #666666;
            }
        }
    }
}
.footer {
    padding: 20px;
    display: flex;
    justify-content: end;
    @{deep} .hc-button{
        width: 80px;
        height: 32px;
        font-size: 12px;
        line-height: 20px;
        padding: 6px 0;
    }
}
.content .handle-form-item /deep/ .hc-input.is-disabled .hc-input__inner {
    background: #F4F5F9;
}

.content{
    @{deep} .hc-table .hc-table__row.has_error{
        .hc-form-item{
            margin: 15px 0 20px;
        }
    }
    @{deep} .hc-form-item__error{
        padding-top: 0;
        line-height: 17px;
    }
}
.new-object .content{
    @{deep} .hc-table .hc-form-item{
        margin: 0;
    }
}
</style>
